module.exports = __webpack_public_path__ + "img/cerficateupdated.ac3c0993.png";